import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core";

import logo_miCyD from '../../img/logomicyda.png';

// const logo = require("../../img/logomicyda.png");

function Page({ texto: Texto }) {
  const classes = useStyles();

  return (
    <Fragment>
        <Box style={{alignItems:"center", justifyContent:"center"}}>
            <Grid container className={classes.grid_container}>
                <Grid item lg className={classes.center} style={{paddingBottom:"4rem"}}>
                {/* <img className={classes.img} src={logo_miCyD} alt="MiCyD" /> */}
                {/* <Typography className={classes.title} variant="h5">{Texto}</Typography> */}
                <CircularProgress color="primary"   />
                </Grid>
            </Grid>
      </Box>
    </Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  grid_container: {
    alignContent: "center",
    alignItems: "center",
  },
  center: {
    textAlign: "center",
    paddingTop: theme.spacing(11),
  },
  img: {
    height: 150,
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  linearProgress: {
    marginLeft: "60vh",
    marginRight: "60vh",
  },
  title: {
    margin: theme.spacing(3, 1, 3, 1),
  }
}));

export default Page;
